import moment from 'moment';

import { EditingTenantOwnTermsOfServiceEntity } from '@/admin/domains';

export const editingTenantOwnTermsOfService: EditingTenantOwnTermsOfServiceEntity = {
  tenantCode: 'tenant',
  body: '# 利用規約(v1)\n\n## インデックス\nテキストテキストテキストテキストテキストテキストテキストテキスト\nテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト\n## インデックス\nテキストテキストテキストテキストテキストテキストテキストテキスト\nテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト\n',
  version: 1,
  createdBy: 'user01',
  createdAt: moment().add(-3, 'hours'),
  updatedBy: 'user01',
  updatedAt: moment().add(-3, 'hours'),
};
